import { z } from 'zod';

export const healthComponentSchema = z.object({
  ok: z.boolean(),
  detail: z.string().optional(),
  latencyMs: z.number().optional(),
});

export const healthSchema = z.object({
  ok: z.boolean(),
  db: healthComponentSchema,
  redis: healthComponentSchema,
  meta: healthComponentSchema,
  queueDepth: z.object({ send: z.number(), webhook: z.number(), maintenance: z.number() }),
  oldestQueuedAt: z.string().datetime().nullable(),
  phoneStatus: z.string().nullable(),
  qualityRating: z.string().nullable(),
  messagingTier: z.number().int().nullable(),
  uniqueRecipientsLast24h: z.number().int(),
  lastWebhookAt: z.string().datetime().nullable(),
  workerHeartbeatAt: z.string().datetime().nullable(),
  version: z.string(),
});
export type Health = z.infer<typeof healthSchema>;

export const overviewStatsSchema = z.object({
  today: z.object({
    queued: z.number().int(),
    sent: z.number().int(),
    delivered: z.number().int(),
    read: z.number().int(),
    failed: z.number().int(),
    cancelled: z.number().int(),
  }),
  daily: z.array(
    z.object({ date: z.string(), sent: z.number().int(), failed: z.number().int() }),
  ),
  topErrors: z.array(
    z.object({
      errorCode: z.number().int().nullable(),
      errorTitle: z.string().nullable(),
      count: z.number().int(),
    }),
  ),
  unhealthyTemplates: z.array(
    z.object({ name: z.string(), language: z.string(), status: z.string() }),
  ),
});
export type OverviewStats = z.infer<typeof overviewStatsSchema>;
